export { SponsoredBrandCarouselV2 } from './sponsored-brand-carousel-v2';
